export const SET_DATA = "SET_DATA";
export const SET_ENDPOINT = "SET_ENDPOINT";
export const SET_STOREDATA = "SET_STOREDATA";
export const SET_CURRENCY_SYMBOL = "SET_CURRENCY_SYMBOL";
export const SET_ORDER_DATA = "SET_ORDER_DATA";
export const SET_USER_LOACATION = "SET_USER_LOACATION";
export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY";
export const SET_THEME_COLOR = "SET_THEME_COLOR";
export const SET_APP_CONFIGS = "SET_APP_CONFIGS";
export const IS_FETCHING_APP_CONFIGS = "IS_FETCHING_APP_CONFIGS";
